module.exports = __webpack_public_path__ + "static/media/features-split-image-01.4f88f7e3.svg";